import GatsbyImage, { FluidObject } from "gatsby-image"
import React from "react"

export interface AvatarProps {
  data: {
    avatarImage: {
      childImageSharp: {
        fluid: FluidObject,
      }
    }
  }
  size?: number
}

export default function Avatar({ data, size=10 }: AvatarProps) {
  return (
    <div style={{
      backgroundColor: "#f4f4f4",
      width: `${size}%`,
      borderColor: "#0c0c0c",
      borderStyle: "solid",
      borderWidth: "2px",
      borderRadius: "50%",
      boxShadow: "0px 0px 30px -1px #ffa5a5",
    }}>
      <GatsbyImage
        fluid={data.avatarImage.childImageSharp.fluid}
        alt='Avatar'
        draggable={false}
        style={{
          overflow: "visible",
        }}
        imgStyle={{
          transform: "scale(1.2, 1.2)",
          top: 14,
          left: -2,
        }}
      />
    </div>
  )
}
